import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HaHeaderViewServiceService } from '../../../modules/HospitalPanel/services/HaHeaderView.service';

@Component({
  selector: 'app-switch-view-button',
  templateUrl: './switch-view-button.component.html',
  styleUrls: ['./switch-view-button.component.css']
})
export class SwitchViewButtonComponent implements OnInit {

  viewId:boolean;
  @Output() changeView = new EventEmitter();
  @Output() stopLoader = new EventEmitter();
  @Output() changeText = new EventEmitter();

  constructor(private viewService: HaHeaderViewServiceService) { }

  ngOnInit() {
    this.viewId = this.viewService.getViewId();
    this.changeView.emit(this.viewId);
    this.addBorder(this.viewId);
  }

  addBorder(type) {
    if (!type) {
      document.getElementById('card').style.border = '1px solid var(--main-blue-dark)';
      document.getElementById('list').style.border = '1px solid transparent';

    } else {
      document.getElementById('card').style.border = '1px solid transparent';
      document.getElementById('list').style.border = '1px solid var(--main-blue-dark)';
    }
  }

  switchView(val, text) {
    let status = val === 1 ? false : true;
    this.changeView.emit(status);
    this.addBorder(status);

    if (text !== '-') {
      this.changeText.emit(text);
    }
     let set = this.viewService.updateView(status);
    // this.viewId = this.viewService.getViewId();
    this.viewService.updateHaListView(true).subscribe((data) => {
      this.stopLoader.emit(false);
    });

  }



}
